import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOChControl } from "../models/BOChControl.model";

@Injectable({
  providedIn: 'root'
}

)
export class ChControlService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ChControl/';

    constructor(private http:HttpClient){}
//#region First

    getAllByPatientId(patientId:number):Observable<BOChControl[]>{
        return this.http.get<BOChControl[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    }

    getAllByClinicHistoryId(clinicHistoryId:number):Observable<BOChControl[]>{
        return this.http.get<BOChControl[]>(this.myAppUrl + this.myApiUrl+'getAllByClinicHistoryId/'+clinicHistoryId);
    }

//#endregion First

//#region Single
  createOrUpdateChControlSingle(clinicHistoryId:number, disease:BOChControl):Observable<BOChControl>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOChControl>(this.myAppUrl + this.myApiUrl + 'createOrUpdateChControlSingle/' + clinicHistoryId,body,httpOptions);
  }

deleteChControlSingle(id:number):Observable<BOChControl>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOChControl>(this.myAppUrl + this.myApiUrl + 'deleteChControlSingle/' + id,null,httpOptions);
    }


//#endregion Single

}
